<div class="loader-container" *ngIf="showLoader">
    <div class="loader">
     <!-- <img src="https://webstockreview.net/images/settings-icon-png-5.png"/> -->
     <img src="./../../../assets/images/rasahriday-logo.png"/>
     <span class="loading-text">Loading...</span>
    </div>
</div>